import { HistoryListViewModel } from '@/presentation/viewmodels/history/historyListViewModel'
import { HistoryPageStateViewModel } from '@/presentation/viewmodels/history/historyPageStateViewModel'
import { HistorySourceCodeViewModel } from '@/presentation/viewmodels/history/historySourceCodeViewModel'

export class HistoryPresenter {
  private historyPageStateViewModel: HistoryPageStateViewModel
  private historyListViewModel: HistoryListViewModel
  private historySourceCodeViewModel: HistorySourceCodeViewModel

  constructor(
    historyPageStateViewModel: HistoryPageStateViewModel,
    historyListViewModel: HistoryListViewModel,
    historySourceCodeViewModel: HistorySourceCodeViewModel
  ) {
    this.historyPageStateViewModel = historyPageStateViewModel
    this.historyListViewModel = historyListViewModel
    this.historySourceCodeViewModel = historySourceCodeViewModel
  }

  async initState(userId: string, problemId: string): Promise<void> {
    this.historyListViewModel.setHistoryList({})
    this.historyPageStateViewModel.setHistoryExpandedList({})
    this.historyPageStateViewModel.setHistoryLoadingList({})
    this.historyPageStateViewModel.setPageIndex(0)
    this.historyPageStateViewModel.setIsNotMoreHistoryList(false)
    this.historySourceCodeViewModel.setHistorySourceCodeList({})
    await this.addHistoryList(userId, problemId, 0)
  }

  async addHistoryList(userId: string, problemId: string, pageIndex: number): Promise<void> {
    await this.historyListViewModel.fetchHistoryList(userId, problemId, pageIndex)
    for (const judgeId in this.historyListViewModel.historyList.value) {
      this.historyPageStateViewModel.setHistoryExpandedFlag(Number(judgeId), false)
      this.historyPageStateViewModel.setHistoryLoadingFlag(Number(judgeId), false)
    }
  }

  async clickSummary(judgeId: number): Promise<void> {
    if (!this.historySourceCodeViewModel.isAlreadySourceCodeRequested(judgeId)) {
      this.historyPageStateViewModel.setHistoryLoadingFlag(judgeId, true)
      await this.historySourceCodeViewModel.fetchHistorySourceCodeList(judgeId)
      this.historyPageStateViewModel.setHistoryLoadingFlag(judgeId, false)
    }
    this.reverseHistoryExpandedFlag(judgeId)
  }

  private reverseHistoryExpandedFlag(judgeId: number): void {
    const currentFlag = this.historyPageStateViewModel.historyExpandedList.value[judgeId]
    this.historyPageStateViewModel.setHistoryExpandedFlag(judgeId, !currentFlag)
  }
}
